import * as React from 'react'
import clsx from 'clsx'
import { useCalendarCell } from '@react-aria/calendar'

import { Text } from '@wartek-id/text'

import styles from 'app/KinerjaShared/components/DatePicker/DatePicker.module.css'

import type { AriaCalendarCellProps } from '@react-aria/calendar'
import type { CalendarState, RangeCalendarState } from '@react-stately/calendar'

export interface CalendarCellProps {
  date: AriaCalendarCellProps['date']
  state: RangeCalendarState | CalendarState
}

export function CalendarCell({ state, date }: CalendarCellProps) {
  const ref = React.useRef<HTMLDivElement>(null)
  const {
    cellProps,
    buttonProps,
    isSelected,
    isOutsideVisibleRange,
    formattedDate,
    isDisabled,
    isUnavailable,
    // isInvalid,
  } = useCalendarCell({ date }, state as any, ref)

  const cellClasses = clsx(
    styles.calendarCellItem,
    isOutsideVisibleRange || isDisabled
      ? styles.calendarCellItemDateDisabled
      : isUnavailable
      ? styles.calendarCellItemDateUnavailable
      : [
          styles.calendarCellItemDate,
          isSelected && styles.calendarCellItemDateSelected,
        ]
  )

  return (
    <td {...cellProps}>
      <div
        {...buttonProps}
        ref={ref}
        className={cellClasses}
        data-testid={isSelected && 'selected-date'}
      >
        <Text>{formattedDate}</Text>
      </div>
    </td>
  )
}
